__webpack_require__.p = "/puzzle-fruit/";